import { ClassNames } from '@emotion/react';
import '../css/Viewpage.css';
import { toast, ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { Oval } from "react-loader-spinner";
import { Navigate, useNavigate, Link } from 'react-router-dom';
import logo from '../images/logo.jpeg';
import user from '../images/user.png';
import Notification from './Notification';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import default_avatar from '../images/default_avatar.png';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import RecentlyJoinedResponse from '../model/response/RecentlyJoinedResponse';
import ProfileListData from '../model/response/ProfileListData';




function HomeList() {
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    const savedImage = localStorage.getItem("image")

    const [isLoading, setIsLoading] = useState(false)
    const [showNotif, setShowNotif] = useState(false);
    const [activeUser, setActiveUser] = useState([]);
    const [users, setUsers] = useState([]);
    const [showMenu, setShowMenu] = useState(false);
    const [showsubMenu, setShowsubMenu] = useState(false);

    const navigation = useNavigate();


    function clicktoCustomerdetailsscreen(userId) {
        navigation('/Customerdetails', { state: { userId: userId } })
    }

    function clickLogin() {
        localStorage.clear();
        localStorage.removeItem('loginVal');
        localStorage.removeItem('token');


        navigation('/login')
    }

    function clickEditprofile() {
        navigation('/Editprofile')
    }
    function clickInterestPage() {
        navigation('/Interestpage')
    }
    function clickSearchPage() {
        navigation('/Searchpage')
    }
    function clicktoViewpage() {
        navigation('/Viewpage')
    }

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    useEffect(() => {
        getRecentlyJoinedAPIcall();
        recommendedAPICall();


    }, []);
    function getRecentlyJoinedAPIcall() {
        setIsLoading(true);

        console.log("Response:", "response.data");
        axios.get(
            ApiConfig.getUrl("User/recently_joined"),
            {
                params: {
                    UserId: loginVal.user_Id
                },

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);

                if (api.statusCode == 200) {

                    setIsLoading(false);
                    const results = api.response?.results.map(item => RecentlyJoinedResponse.fromJson(item)) || [];
                    console.log("Response:", api.results);
                    setUsers(results);

                }
                // } else {
                //   showToastFailed(api.errorMessage);
                // }

            })
            .catch(error => {
                setIsLoading(false);
                // showToastFailed(error);
                // console.error("Error:", error);
            });
    }

    function recommendedAPICall() {


        axios.get(
            ApiConfig.getUrl("User/recommendProfile"),
            {
                params: {
                    UserId: loginVal.user_Id
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                if (api.statusCode == 200) {
                    setIsLoading(false);
                    const result = api.response?.result.map(item => ProfileListData.fromJson(item)) || [];
                    console.log("Response:", api.results);
                    setActiveUser(result);
                } else {
                    showToastFailed(api.errorMessage);
                }

            })
            .catch(error => {
                showToastFailed(error);
                console.error("Error:", error);
            });
    }

    function clickSettingspage() {
        navigation('/settingspage')
    }

    const disableRightClick = (e) => {
        e.preventDefault();
    };



    return (
        <>


            <ToastContainer />
            <div className='fullview d-flex flex-column' onContextMenu={disableRightClick}>
                {isLoading && (
                    <div className="loader-overlay">
                        <Oval
                            height={60}
                            width={60}
                            color="var(--primary-color)"
                            secondaryColor="#cccccc"
                            strokeWidth={4}
                            visible={true}
                        />
                    </div>
                )}

                <div className="top-bar">
                    <div className='container'>
                        <ul className="d-flex align-items-center mb-0 position-relative">
                            {/* <li>Home</li>
               <li>Matches</li> */}
                            <img src={logo} alt='logo' style={{ width: '70px' }} />
                            <li onClick={clicktoViewpage} className="m-1 p-1">
                                <i className="bi bi-people d-inline m-2"></i>
                                <span className="d-none d-sm-inline text-decoration-none text-dark">All Matches</span>
                            </li>
                            <li onClick={clickInterestPage} className='m-2 p-1'><i className="bi bi-heart d-inline m-2"></i>
                                <span className="d-none d-sm-inline text-decoration-none text-dark">Interests</span></li>

                            <li onClick={clickSearchPage} className='m-2 p-1'><i className="bi bi-search d-inline m-2"></i>
                                <span className="d-none d-sm-inline text-decoration-none text-dark">Search</span></li>

                            <li className='m-2 p-1' onClick={() => setShowNotif(true)} >
                                <i className="bi bi-bell d-inline m-2"></i>
                                <span className="d-none d-sm-inline  text-decoration-none text-dark">Notification</span></li>
                            <Notification
                                show={showNotif}
                                onClose={() => setShowNotif(false)}
                            />


                            {/* <button className='top-button'>Switch account</button> */}
                            <div style={{ position: "relative", display: "inline-block" }}>
                                <img style={{ width: "50px", height: "50px", borderRadius: "50% " }}

                                    src={savedImage || default_avatar}
                                    onClick={() => setShowMenu(!showMenu)}
                                />
                                {showMenu && (
                                    <div className="dropdown-menu show" style={{ position: "absolute", right: "5px" }}>
                                        <div className="dropdown-item " style={{ cursor: "pointer" }} onClick={clickEditprofile}>Edit Profile</div>
                                        <div className="dropdown-item " style={{ cursor: "pointer" }} onClick={clickSettingspage}  >Settings</div>
                                        {/* {showsubMenu && (
                                 <div className="dropdown-item" style={{ cursor: "pointer", textAlign: "center",backgroundColor:"darkorange",color:"white"}}>Block List</div>
                                 )} */}
                                        <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickLogin}>Logout</div>
                                    </div>
                                )}
                            </div>
                        </ul>
                    </div>
                </div>



                <div className='row container p-2' style={{ marginTop: "100px" }}>

                    <label className='h5 b'>Recently Joined users</label>

                    <div className='client p-1 m-1' onClick={() => setShowMenu(false)} style={{
                        borderRadius: "none", boxShadow: "none",

                        boxSizing: "none",
                        border: "none"
                    }}>
                        <div
                            className='d-flex flex-nowrap overflow-auto horizontal-scroll'
                            style={{
                                whiteSpace: "nowrap",
                                scrollbarWidth: "thin"
                            }}
                        >

                            {
                                users.length > 0 ? (
                                    users.map((item, index) => (
                                        <div
                                            key={item.userId}
                                            className='card mt-3 me-3 d-flex flex-column align-items-center flex-shrink-0'
                                            style={{
                                                width: "160px",
                                                height: "260px",
                                                background: item.themeColour || localStorage.getItem("themeColor"),
                                                minWidth: "140px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => clicktoCustomerdetailsscreen(item.userId)}
                                        >
                                            <div className='p-3 text-center'>
                                                <img
                                                    className="list-a-img mb-1"
                                                    src={
                                                        item.profilePath == null || item.profilePath == ""
                                                            ? default_avatar
                                                            : item.profilePath
                                                    }
                                                    style={{
                                                        objectFit: "cover",
                                                        width: "100px",
                                                        height: "100px",
                                                        borderRadius: "50%",
                                                        border: "2px solid #FFA500"
                                                    }}
                                                />

                                                <div>
                                                    <b className='name text-wrap'>
                                                        {item.name}
                                                    </b>
                                                </div>

                                                <label className='normal'>
                                                    IMIT{item.userNum}
                                                </label>
                                                <br />

                                                <label className='normal'>
                                                    {item.age} yrs, {item.height} CM
                                                </label>
                                            </div>

                                            <button
                                                className='text-white'
                                                style={{ backgroundColor: "var(--primary-color)" }}
                                            >
                                                View Profile
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        className="d-flex justify-content-center align-items-center w-100"
                                        style={{
                                            minHeight: "150px",
                                            color: "#777",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        No list available
                                    </div>
                                )
                            }
                        </div>
                    </div>


                </div>



                <div className='row container p-2 mb-5' style={{ marginTop: "10px" }}>
                    <label className='h5 b'>Daily Recommendations</label>

                    <p>Recommended Matches for Today</p>

                    <div className='client p-1 m-1' style={{
                        marginBottom: "100px", borderRadius: "none", boxShadow: "none",
                        boxSizing: "none", border: "none"
                    }} >

                        <div
                            className='d-flex flex-nowrap overflow-auto horizontal-scroll'
                            style={{
                                whiteSpace: "nowrap",
                                scrollbarWidth: "thin"
                            }}
                        >

                            {
                                activeUser.length > 0 ? (
                                    activeUser.map((item) => (
                                        <div
                                            key={item.userId}
                                            className='card mt-3 me-3 d-flex flex-column align-items-center flex-shrink-0 '
                                            style={{
                                                width: "160px", height: "260px",
                                                minWidth: "140px",
                                                cursor: "pointer", background: item.themeColour || localStorage.getItem("themeColor")
                                            }}
                                            onClick={() => clicktoCustomerdetailsscreen(item.userId)}
                                        >

                                            <div className='p-3 text-center' style={{ borderRadius: "50%" }}>

                                                <img
                                                    className="list-a-img mb-2"
                                                    src={
                                                        item.profilePath == null || item.profilePath == ""
                                                            ? default_avatar
                                                            : item.profilePath
                                                    }
                                                    style={{
                                                        objectFit: "cover",
                                                        width: "100px", height: "100px", borderRadius: "50%", border: "2px solid #FFA500"
                                                    }}
                                                />

                                                <div>
                                                    <b className='name' style={{
                                                        overflowWrap: "break-word", background: item.themeColourText || "#131111",
                                                        WebkitBackgroundClip: "text",
                                                        WebkitTextFillColor: "transparent",
                                                        backgroundClip: "text"
                                                    }}>
                                                        {item.name}
                                                    </b>
                                                </div>

                                                <label className='normal' style={{
                                                    background: item.themeColourNumber || "#333333",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent",
                                                    backgroundClip: "text",
                                                    fontWeight: "bold"
                                                }}>
                                                    IMIT{item.userNum}
                                                </label><br />

                                                <label className='normal' style={{
                                                    background: item.themeColourText || "#333333",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent",
                                                    backgroundClip: "text",
                                                    fontWeight: "bold"
                                                }}>
                                                    {item.age} yrs, {item.height} CM
                                                </label>
                                            </div>
                                            <button className='text-white' style={{ backgroundColor: "var(--primary-color)" }}>View Profile</button>

                                        </div>
                                    ))
                                ) : (
                                    <div
                                        className="d-flex justify-content-center align-items-center w-100 fs-2 ms-5"
                                        style={{
                                            minHeight: "150px",
                                            color: "#777",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        No list available
                                    </div>
                                )
                            }

                        </div>

                    </div>
                </div>

            </div >
            <footer className='bg-dark text-white text-center'>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>

    );
}
export default HomeList;
